__turbopack_context__.v({
  "author_name": "styles-module-scss-module__hlr8Tq__author_name",
  "author_text": "styles-module-scss-module__hlr8Tq__author_text",
  "content": "styles-module-scss-module__hlr8Tq__content",
  "date_range": "styles-module-scss-module__hlr8Tq__date_range",
  "image_wrapper": "styles-module-scss-module__hlr8Tq__image_wrapper",
  "link": "styles-module-scss-module__hlr8Tq__link",
  "remove_horizontal_padding": "styles-module-scss-module__hlr8Tq__remove_horizontal_padding",
});
